import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Navigator } from 'src/app/components/menu/navigator';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { UtilsService } from '../utils/utils.service';

@Injectable({
	providedIn: 'root'
})
export class CashierContentService {

	private bonusOfferValueSubject = new BehaviorSubject('EMPTY_DEPOSIT_DEPOSIT');
	public bonusOfferValue = this.bonusOfferValueSubject.asObservable();

	public pageConfigs: any;
	public selectedBonus: any;
	public stopBestBonusFlag: any;

	constructor(
		public http: HttpClient,
		public utils: UtilsService,
		public navigator: Navigator
	) {
		this.pageConfigs = new Map();
	}

	public updateBonusOfferValue(value: any) {
		return this.bonusOfferValueSubject.next(value);
	}

	public getPageConfig(pageName) {
		return new Promise((resolve) => {
			if (this.pageConfigs.has(pageName)) {
				let response = this.pageConfigs.get(pageName);
				resolve(response);
			} else {

				const fileUrl = this.utils.getDepositConfigNetworkPath("deposit_configs/" + pageName) + '.config?v=' + new Date().getTime();

				this.http.get(fileUrl).subscribe({
					next: (response: any) => {
						if (response != null) {
							this.pageConfigs?.set(pageName, response);
							resolve(response);
						}
					},
					error: () => {
						console.warn('Deposit configs not loading from CDN for', pageName);

						const localPath = "/assets/deposit_configs/" + pageName + '.config';
						this.http.get(localPath).subscribe((res: any) => {
							if (res != null) {
								this.pageConfigs.set(pageName, res);
								resolve(res);
							}
						});
					}

				});
			}
		});
	}

	public getSelectedBonus() {
		return this.selectedBonus;
	}

	public setSelectBestOne(val) {
		if (val) {
			return this.stopBestBonusFlag = true;
		}
		return this.stopBestBonusFlag = false
	}

	public setSelectedBonus(data) {
		return this.selectedBonus = data;
	}


	public getDefaultPayments(paymentType, index) {

		let i: number = 0;

		let amounts = []

		while (i < 11) {
			if (typeof paymentType[index]['default_amt_' + (i + 1)] !== 'undefined') {
				amounts.push(paymentType[index]['default_amt_' + (i + 1)]);
			} else {
				break;
			}
			i++;
		}

		return amounts;
	}

	public getVendorPage(link) {
		let page = '';

		switch (link) {
			case 'EC':
				break;
			case 'EFT':
				break;
			case 'BD':
				break;
			case 'GP':
				page = 'DepositVipComponent';
				break;
			case 'NETL':
				//return $this->_forward('deposit-neteller', null, null, $params);
				break;
			case 'VI':
			case 'MC':
			case 'AM':
			case 'CREDIT':
				page = 'DepositCreditcardComponent';
				break;
			case 'PPD':
				page = 'DepositPaypalComponent';
				break;
			case 'SL':
				//deposit-sightline
				page = 'DepositPlayplusComponent';
				break;
			case 'PNM':
				page = 'DepositPaynearmeComponent';
				break;
			case 'CAGEPA':
			case 'CAGE':
				page = 'DepositCageComponent';
				break;
			case 'PWB':
				page = 'DepositPaywithmybankComponent';
				break;
			case 'VEN':
				page = "DepositVenmoComponent";
				break;
			case 'WI':
				page = "DepositWireComponent";
				break;
			case 'GDIE':
				page = 'DepositGigadetInteracPage';
				break;
			case 'INSTA':
				page = 'DepositInstaDebitPage';
				break;
			case 'PAIBT':
				page = 'DepositInstantBankTransferPage';
				break;
			case 'ACH':
				page = 'DepositECheckBasePage';
				break;
			case 'IDS':
				page = 'DepositIDebitPage';
				break;
			case 'NS':
				page = 'DepositNeosurfComponent';
				break;
			case 'PWB':
				page = 'DepositPaywithmybankComponent';
				break;
			case 'VEN':
				page = "DepositVenmoComponent";
				break;
			case 'WI':
				page = "DepositWireComponent";
				break;
			case 'VVAP':
				page = "DepositApplepayComponent";
				break;
			default:
				page = 'DepositMainComponent';
				break;
		}

		return page;
	}

	public onBackHandler(navigateBackPage = null): any {
		if (!navigateBackPage) return this.navigator.back();
		if (navigateBackPage == "default") return this.navigator.navigateTo("DepositMainComponent", { multipleModals: true });
		if (navigateBackPage == "sidemenu") return this.navigator.back();
		if (navigateBackPage == "navbar" || navigateBackPage == "navbar-text") return this.navigator.dismissAll();
		if (navigateBackPage == "promotions") return this.navigator.dismissAll();
		return this.navigator.navigateTo(navigateBackPage);
	}
}
